const getStatus = (state) => {
  const { status, error } = state.commonState.upload;
  return { status, error };
};

export default {
  getStatus,
};
